import * as types from './mutation-types'

export default {
  [types.SET_REGISTROS_POR_PAGINA] (state, registrosPorPagina) {
    state.registrosPorPagina = registrosPorPagina
  }
}
